export default __webpack_public_path__ + "static/free_materials_es-5a5f0d7092e9dfab5496b14f91686832.jpeg";